// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchChildCompanyGraphQl } from "../../actions/companyActions";
import { addCompanyTab } from "../../actions/userActions";
import GeneralCompany from "./GeneralCompany";
import { GetNotesFirstLine } from "../../../global/functions/MultilLineStrings";
import { buildCompanyInfoJson } from "../../components/companies/CompileCompanytoJson";
import AuthorisedLabel from "../../components/companies/AuthorisedLabel";
import type { StateType, DispatchType } from "../../global/types/redux";

import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import Grid from "@material-ui/core/Grid";

class CompanyList extends Component<*> {

  handleChange = panel => (event) => {
    this.props.loadChildCompany();
    this.props.actions.fetchChildCompanyGraphQl(panel, this.setStep);
  };

  setStep = (company): * => {
    this.props.actions.addCompanyTab({ label: company.name, id: company.id, component: <GeneralCompany /> });
    this.props.loadChildCompany();
  }

  render(): * {
    const companies = this.props.children;
    const list = companies && companies.map((item, i): * => {
      const company = buildCompanyInfoJson(item);
      return (
        <ExpansionPanel expanded={false} onChange={this.handleChange(company.id)} key={i}>
          <ExpansionPanelSummary expandIcon={<OpenInNewIcon />}>
            <Typography variant="subtitle1" className="heading">{company.name}</Typography>
            {/*<Badge color="primary" badgeContent={company.licences.edges.length} classes={{ badge: classes.badge }}>
              <Typography variant="subtitle1">Licences</Typography>
            </Badge>*/}
            <Typography variant="subtitle1" className="subheading">{GetNotesFirstLine(company.notes)}</Typography>
            {company.level === "R" &&
              <Typography variant="subtitle1" className="subheading">
                <AuthorisedLabel status={company.authorisedReseller} />
              </Typography>
            }
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <span></span>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      );
    });
    return (
      <div className="app-panel-content panel-top-margin" >
        <Grid container spacing={24}>
          <Grid item xs={12}>
            {list}
          </Grid>
        </Grid>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators({ fetchChildCompanyGraphQl, addCompanyTab }, dispatch)
});

export default connect(null, mapDispatchToProps)(CompanyList);
